import classnames from 'classnames';
import React from 'react';
import styles from './Spinner.scss';
const Spinner = ({ title = null, inline = true, fullScreen = false, className = null, bottom = false, }) => (<span className={classnames(className, styles.spinner, {
    [styles.block]: !inline && !fullScreen,
    [styles.bottom]: !inline && bottom,
    [styles.withTitle]: !!title,
    [styles.fullScreen]: fullScreen,
}, 'spinner-wrap')}>
    <i className="icon-spinner4 spinner"/>
    {title}
  </span>);
export default Spinner;
